export default {
    'daily-report': 'Daily report',
    'visits': 'Visits'
}